import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import { useTranslation } from 'common/i18n/hooks';
import { ModalReact } from 'common/components/modal';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import styles from './_unsaved-changes-modal.module.styl';
export const UnsavedChangesModal = (props: InstanceProps<boolean>) => {
  const {
    t
  } = useTranslation();
  const onClose = () => {
    props.onResolve(false);
  };
  const onSave = () => {
    props.onResolve(true);
  };
  return <ModalReact modalTitle={t("experiments.unsaved-changes.title")} open={props.isOpen} hideCloseButton data-sentry-element="ModalReact" data-sentry-component="UnsavedChangesModal" data-sentry-source-file="_unsaved-changes-modal.tsx">
      <div className={styles.modalContent}>
        <div className={styles.modalInner}>
          <div className={styles.modalTitle}>{t("experiments.unsaved-changes.title")}</div>
          <div className={styles.modalDescription}>{t("experiments.unsaved-changes.description")}</div>
          <div className={styles.modalFooter}>
            <ButtonReact onClick={onSave} theme={ButtonTheme.Primary} data-sentry-element="ButtonReact" data-sentry-source-file="_unsaved-changes-modal.tsx">
              {t("common.save")}
            </ButtonReact>
            <ButtonReact onClick={onClose} theme={ButtonTheme.Tertiary} data-sentry-element="ButtonReact" data-sentry-source-file="_unsaved-changes-modal.tsx">
              {t("common.dont-save")}
            </ButtonReact>
          </div>
        </div>
      </div>
    </ModalReact>;
};
export const openUnsavedChangesModal = create(UnsavedChangesModal);